import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {getDateUtilDefaultInstance} from '/util/date.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './ReferralExpirationDate.styles';

interface ReferralExpirationDateProps {
  item: {
    expirationTime: string;
  };
  isExpired: boolean;
}

export const ReferralExpirationDate: React.FC<ReferralExpirationDateProps> = ({
  item,
  isExpired,
}) => {
  const expirationTime = get(item, 'expirationTime', '');

  if (!expirationTime) {
    return null;
  }

  const dateUtil = getDateUtilDefaultInstance();
  const formattedDate = dateUtil.formatDate(expirationTime, 'MM/dd/yyyy');

  if (!formattedDate) {
    return null;
  }

  const textStyle = [
    styles.text,
    isExpired ? styles.expired : styles.notExpired,
  ];

  const expiresText = isExpired ? 'Expired' : 'Expires';

  return (
    <View {...testProperties(Reports.reportReferralExpirationDate)}>
      <Text style={textStyle} isBold={true} accessible={false}>
        {expiresText} {formattedDate}
      </Text>
    </View>
  );
};

export default ReferralExpirationDate;
